import { HTMLAttributes } from "react";

export default function NextJS(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        d="M24 2C11.8656 2 2 11.8656 2 24C2 36.1344 11.8656 46 24 46C27.85 46 31.4594 45.0031 34.5875 43.2844L18.6375 21.0094V33.5906H16.3V16.3687H18.6375L35.9969 42.425C42.0125 38.5062 46 31.7344 46 24C46 11.8656 36.1344 2 24 2ZM31.5969 31.0812L29.0187 27.1969V16.3687H31.5969V31.0812Z"
        fill="black"
      />
    </svg>
  )
}
